import React from 'react';
import { Send, Clock, Paperclip, Trash2, Edit } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function Outbox() {
  const emails = [{
    id: 1,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12345 - Shortage Claim',
    amount: '$500.00',
    attachments: 2,
    status: 'ready'
  }, {
    id: 2,
    to: 'vendor_support@walmart.com',
    subject: 'Dispute - PO# WM-9921 - Pricing Error',
    amount: '$1,250.00',
    attachments: 3,
    status: 'ready'
  }, {
    id: 3,
    to: 'ap@target.com',
    subject: 'Dispute - PO# TGT-8812 - Shortage',
    amount: '$320.00',
    attachments: 2,
    status: 'scheduled',
    time: 'Tomorrow, 9:00 AM'
  }, {
    id: 4,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12346 - Shortage Claim',
    amount: '$150.00',
    attachments: 2,
    status: 'ready'
  }, {
    id: 5,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12347 - Shortage Claim',
    amount: '$800.00',
    attachments: 2,
    status: 'ready'
  }];
  return <div className="space-y-6" data-id="element-595">
      <div className="flex items-center justify-between" data-id="element-596">
        <div data-id="element-597">
          <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-598">
            Outbox
          </h2>
          <p className="text-slate-500 mt-1" data-id="element-599">Review and send dispute emails.</p>
        </div>
        <div className="flex space-x-3" data-id="element-600">
          <button className="px-4 py-2 bg-white border border-slate-300 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 flex items-center space-x-2" data-id="element-601">
            <Clock className="w-4 h-4" data-id="element-602" />
            <span data-id="element-603">Schedule All</span>
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 shadow-sm flex items-center space-x-2" data-id="element-604">
            <Send className="w-4 h-4" data-id="element-605" />
            <span data-id="element-606">Send All (5)</span>
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-607">
        <div className="overflow-x-auto" data-id="element-608">
          <table className="w-full text-sm text-left" data-id="element-609">
            <thead className="bg-slate-50 text-slate-500 font-medium" data-id="element-610">
              <tr data-id="element-611">
                <th className="px-6 py-3 w-8" data-id="element-612">
                  <input type="checkbox" className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-613" />
                </th>
                <th className="px-6 py-3" data-id="element-614">Recipient / Subject</th>
                <th className="px-6 py-3" data-id="element-615">Amount</th>
                <th className="px-6 py-3" data-id="element-616">Attachments</th>
                <th className="px-6 py-3" data-id="element-617">Status</th>
                <th className="px-6 py-3 text-right" data-id="element-618">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-619">
              {emails.map(email => <tr key={email.id} className="hover:bg-slate-50 transition-colors group" data-id="element-620">
                  <td className="px-6 py-4" data-id="element-621">
                    <input type="checkbox" className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-622" />
                  </td>
                  <td className="px-6 py-4" data-id="element-623">
                    <div className="font-medium text-slate-900" data-id="element-624">{email.to}</div>
                    <div className="text-xs text-slate-500" data-id="element-625">
                      {email.subject}
                    </div>
                  </td>
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-626">
                    {email.amount}
                  </td>
                  <td className="px-6 py-4" data-id="element-627">
                    <div className="flex items-center text-slate-500 text-xs" data-id="element-628">
                      <Paperclip className="w-3 h-3 mr-1" data-id="element-629" />
                      {email.attachments} files
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-630">
                    {email.status === 'scheduled' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100" data-id="element-631">
                        <Clock className="w-3 h-3 mr-1" data-id="element-632" />
                        {email.time}
                      </span> : <StatusBadge status="neutral" data-id="element-633">Ready to Send</StatusBadge>}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-634">
                    <div className="flex items-center justify-end space-x-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-635">
                      <button className="p-1.5 hover:bg-slate-200 rounded text-slate-500 hover:text-slate-700" data-id="element-636">
                        <Edit className="w-4 h-4" data-id="element-637" />
                      </button>
                      <button className="p-1.5 hover:bg-rose-100 rounded text-slate-500 hover:text-rose-600" data-id="element-638">
                        <Trash2 className="w-4 h-4" data-id="element-639" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}